module.exports = __webpack_public_path__ + "img/staff.cb650001.svg";